/*
 * @Descripttion:
 * @version:
 * @Author: 周志国
 * @Date: 2025-09-08 16:17:44
 * @LastEditors: 周志国
 * @LastEditTime: 2025-09-09 09:44:32
 * @changeLog:
 * @FilePath: /anov-3d-webgl/packages/anov-3d-ability/src/business/Line/interface.ts
 */
import type { Line } from '@anov/3d-core'
import type { options } from './types'

export interface ILine {
  /**
  * 创建线
  * @param options - 参数配置
  */
  createLine: (options: options) => Line
}